export default __webpack_public_path__ + "static/media/team11.c2a89ab6.JPG";